<template>
  <Base icon="mdi-ballot-outline" :satisfied="groupSatisfied || requirement.satisfied" tooltip>
    <span>
      {{ requirement.value }}
    </span>
    <span slot="tooltip">
      {{ first ? 'The ideal candidate' : 'and' }}
      {{ requirement.mandatory ? 'must' : 'could' }}
      {{ requirement.negative ? 'not' : '' }} have
      <strong>{{ requirement.value }}</strong>
      experience
    </span>
  </Base>
</template>

<script>
// Component
import Base from '@/components/guest/opportunities/requirements/Base'

// Helpers
import { mapGetters } from 'vuex'

// Vue Component
export default {
  components: { Base },
  props: {
    requirement: { type: Object, required: true },
    first: { type: Boolean },
    groupSatisfied: { type: Boolean },
  },
}
</script>
